export const APPLICATION = Object.freeze({
    CATALOG_ID: 1,
    TOOLS_ID: 5,
    FORECAST_ID: 6,
    CATALOG_FORECAST_ID: 7
});

export const APPLICATION_PARAMETER = Object.freeze({
    FIRM_ORDER_ID: 1,
    COLUMN_NUMBER_ID: 2,
    PROFIL_MANAGEMENT_ID: 3,
    COPY_ZONE_DATAS_ID: 4,
    ADD_IMAGES_TO_ARTICLES_ID: 5,
    BRAND_WITH_CAMPAIGN: 6,
    REFDT_EQ_AVAILDT: 7
});



// WEBPACK FOOTER //
// ./src/components/admin/brand/constant.js